/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_New_Open_TitleInputs */

const en_case_new_open_title = /** @type {(inputs: Case_New_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a new recovery case`)
};

const pt_br2_case_new_open_title = /** @type {(inputs: Case_New_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir novo caso de recuperação`)
};

/**
* | output |
* | --- |
* | "Open a new recovery case" |
*
* @param {Case_New_Open_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_new_open_title = /** @type {((inputs?: Case_New_Open_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_New_Open_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_new_open_title(inputs)
	return pt_br2_case_new_open_title(inputs)
});